export default __webpack_public_path__ + "static/kaizo-fa84c1d56587d7de15839ddfd0a5ec8e.mp4";